import { z } from 'zod';

export const positionSchema = z.object({
  lat: z.number(),
  lon: z.number(),
});

export const nodeTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  position: positionSchema,
});

export const geographyMappingSchema = z.object({
  shuttle_provider_id: z.string(),
  shuttle_provider_name: z.string(),
  dispatch_provider_id: z.string(),
  dispatch_provider_name: z.string(),
  distance: z.number().optional().nullable(),
});

export type NodeType = z.infer<typeof nodeTypeSchema>;
export type GeographyMapping = z.infer<typeof geographyMappingSchema>;
